import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { closeModal } from 'reducers/modals';
// components
import Modal from 'components/Modal';
import Button from 'components/Button';
import { FormattedMessage, FormattedNumber } from 'react-intl';
// styles
import './WaterMeterRolloverModal.scss';

const WaterMeterRolloverModal = ({
  meterName,
  priorReading,
  priorReadingDate,
  todayReading,
  onEditReading,
  onSaveBaseline,
  closeModal,
}) => {
  const handleEdit = () => {
    closeModal();
    if (onEditReading) onEditReading();
  };

  const handleSave = () => {
    closeModal();
    if (onSaveBaseline) onSaveBaseline();
  };

  return (
    <Modal
      className="WaterMeterRolloverModal"
      title={<FormattedMessage id="component.modal.waterMeterRollover.title" />}
    >
      <section className="modal-body">
        {meterName && <p className="meter-name"><strong>{meterName}</strong></p>}
        <FormattedMessage
          id="component.modal.waterMeterRollover.text"
          tagName="p"
          values={{ todayReading }}
        />
        <div className="readings-comparison">
          <div className="reading">
            <span className="reading-label">
              <FormattedMessage id="component.modal.waterMeterRollover.priorReading" />
            </span>
            <span className="reading-value">
              <FormattedNumber value={priorReading} format="0,0[.]00" />
            </span>
            {priorReadingDate && (
              <span className="reading-date">{priorReadingDate}</span>
            )}
          </div>
          <div className="reading">
            <span className="reading-label">
              <FormattedMessage id="component.modal.waterMeterRollover.todayReading" />
            </span>
            <span className="reading-value">
              <FormattedNumber value={todayReading} format="0,0[.]00" />
            </span>
          </div>
        </div>
      </section>
      <section className="modal-footer flex sticky-on-mobile">
        <Button className="margin-right-1" onClick={handleEdit}>
          <FormattedMessage id="component.modal.waterMeterRollover.editReading" />
        </Button>
        <Button primary onClick={handleSave}>
          <FormattedMessage id="component.modal.waterMeterRollover.saveBaseline" />
        </Button>
      </section>
    </Modal>
  );
};

WaterMeterRolloverModal.propTypes = {
  meterName: T.string,
  priorReading: T.oneOfType([T.number, T.string]).isRequired,
  priorReadingDate: T.string,
  todayReading: T.oneOfType([T.number, T.string]).isRequired,
  onEditReading: T.func,
  onSaveBaseline: T.func,
  closeModal: T.func.isRequired,
};

export default connect(null, { closeModal })(WaterMeterRolloverModal);
